const SELECTOR = "[data-track-home-block-click]"

function trackClick(element: HTMLElement) {
  const blockId = element.dataset.trackHomeBlockClick
  const urlType = element.dataset.urlType
  if (!blockId || !urlType) return

  const variant = element.dataset.variant
  const payload = JSON.stringify(
    variant ? { url_type: urlType, variant } : { url_type: urlType },
  )

  try {
    const blob = new Blob([payload], { type: "application/json" })
    navigator.sendBeacon(`/api/v3/home_blocks/${blockId}/click`, blob)
  } catch {
    // Best-effort tracking; never block navigation on failure.
  }
}

document.addEventListener(
  "click",
  (event) => {
    const target = event.target
    if (!(target instanceof Element)) return

    const link = target.closest(SELECTOR)
    if (link instanceof HTMLElement) trackClick(link)
  },
  { capture: true },
)
